<template>
  <form>
    <div class="box">
      <nav class="level">
        <div class="level-left">
          <h3 class="subTitle">{{title}}</h3>
        </div>
      </nav>
      <section class="row">
        <b-field class="col-md-5 col-lg-4 mb-3">
          <b-input placeholder="Digite o nome da segmentação" v-model="form.name"></b-input>
        </b-field>
      </section>
      <section>
        <b-field class="searchSegments mb-5">
          <InputSelect 
            :currentValue="form.partner"
            name="partner"
            :items="partners"
            label="Selecione o parceiro"
            @set="set" >
          </InputSelect>
        </b-field>
      </section>
      <div v-if="showContent">
        <div class="box">
          <ContentLoading
            :show="showContent"
            :grid="grid"
            :width="300"
            :height="80"
            :mobile-grid="mobileGrid"
            :mobile-width="30"
            :mobile-height="20"
          />
        </div>
        <ContentLoading
          :show="showContent"
          :grid="gridCard"
          :width="300"
          :height="100"
          :mobile-grid="mobileGridCard"
          :mobile-width="30"
          :mobile-height="40"
        />
      </div>
      <section :class="showContent ? 'hidden-inputs' : ''" class="boxCard d-flex align-items-center justify-content-lg-start justify-content-center flex-lg-row flex-column">
        <Card class="w-100 mb-2" title="Selecione um tipo de participante">
          <InputButton name="entity" :items="entities" :currentValue="form.entity" handler="setPropsEntities" @set="set" />
        </Card>
        <div class="group col-12" v-for="(group, groupIndex) in form.groups" :key="groupIndex">
          <span class="empity-group" v-if="group.items.length < 1">Nenhum filtro aplicado!</span>
          <div v-if="showSeparator(groupIndex)" class="group-separator">
            <InputSwitch name="and" :currentValue="group.and" :items="and" handler="andHandler" :groupIndex="groupIndex" @set="set" class="aggregator fixed justify-content-center align-items-center" />
          </div>
          <div class="group-content d-flex">
            <div :class="['group-items', groupIndex === 0 ? 'pt-5' : '']">
              <div class="d-flex align-items-center justify-content-center py-lg-3 py-0" v-for="(item, index) in group.items" :key="index">
                <InputSwitch class="d-flex align-items-center justify-content-center position-relative aggregator-type" v-if="index > 0" :currentValue="transformIfBoolean(item.and)" name="and" :items="and" handler="andHandler" :unclickable="optionsUnclickable(item, groupIndex, index)" :groupIndex="groupIndex" :index="index" @set="set"/>       
                <Card class="filter-card my-lg-0 my-3" v-if="!hasRegisterType(item)" title="Selecione um filtro do participante">
                  <ButtonClose :groupIndex="groupIndex" :index="index" @event="close" />
                  <InputButton name="registerType" :currentValue="item.registerType" :items="registerTypes" handler="setRegisterType" :groupIndex="groupIndex" :index="index" @set="set" />
                  <InputButton v-if="showFrequency(index)" name="frequency" :items="frequency" handler="setFrequency" :groupIndex="groupIndex" @set="set" />                  
                </Card>
                <div>
                  <Card class="card-filter" title="Filtro por Dados" v-if="hasRegisterType(item) && isProps(item)" >
                    <ButtonClose :unclickable="transformIfBoolean(item.unclickable)" :groupIndex="groupIndex" :index="index" @event="close" />
                    <InputSelect :unclickable="transformIfBoolean(item.unclickableField)" name="field" :currentValue="item.field" :items="item.fields" handler="setFieldConfigs" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-if="isDate(item)" name="datetimeOption" :currentValue="item.datetimeOption" handler="datetimeFormat" :items="dateOptions(item.format)" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect name="operator" :currentValue="item.operator" :items="item.operators" handler="changeOperator" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputDate v-if="isDate(item)" name="value" :formatMask="item.formatMask" :format="item.format" :operator="item.operator" :currentValue="item.value" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputMoney v-else-if="isNumber(item)" name="value" :operator="item.operator" :currentValue="item.value" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-else-if="isBoolean(item)" name="value" :currentValue="item.value" :items="booleanOptions" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-else-if="isCombo(item)" name="value" :currentValue="item.value" :items="item.comboOptions" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputText v-else name="value" :currentValue="item.value" :groupIndex="groupIndex" :index="index" @set="set" />
                  </Card>
                  <Card class="card-filter" title="Filtro por Ações" v-if="hasRegisterType(item) && !isProps(item)">
                    <ButtonClose :unclickable="transformIfBoolean(item.unclickable)" :groupIndex="groupIndex" :index="index" @event="close" />
                    <InputSelect :unclickable="transformIfBoolean(item.unclickableType)" name="type" :currentValue="item.type" :items="item.types" handler="setFields" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect :unclickable="transformIfBoolean(item.unclickableField)" name="field" :currentValue="item.field" :items="item.fields" handler="setFieldConfigs" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect name="measure" v-if="hasMeasure(item) && !isFrequency(groupIndex)" :currentValue="item.measure" :items="configurations.measures" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-if="isDate(item) && !isFrequency(groupIndex)" name="datetimeOption" :currentValue="item.datetimeOption" handler="datetimeFormat" :items="dateOptions(item.format)" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-if="isQuantity(item) && isFrequency(groupIndex)" name="frequencyOption" :currentValue="item.frequencyOption" handler="frequencyHandler" :items="frequencyOptions" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect name="operator" :currentValue="item.operator" :items="item.operators" handler="changeOperator" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputDate v-if="isDate(item)" name="value" :formatMask="item.formatMask" :format="item.format" :operator="item.operator" :currentValue="item.value" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-if="isDate(item)" class="mt-3" name="weekendOption" :currentValue="item.weekendOption" :items="weekendOptions" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputMoney v-else-if="isNumber(item)" name="value" :operator="item.operator" :currentValue="item.value" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-else-if="isBoolean(item)" name="value" :currentValue="item.value" :items="booleanOptions" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputSelect v-else-if="isCombo(item)" name="value" :currentValue="item.value" :items="item.comboOptions" :groupIndex="groupIndex" :index="index" @set="set" />
                    <InputText v-else name="value" :currentValue="item.value" :groupIndex="groupIndex" :index="index" @set="set" />
                  </Card>
                </div>
              </div>
            </div>
            <ButtonIcon v-if="form.entity && !isFrequency(groupIndex)" class="ml-3" text="Filtro" icon="plus" :groupIndex="groupIndex" @handler="addItem" />
          </div>
          <div class="group-header justify-content-center pt-2">
            <div class="header-content">
              <InputSwitch name="nin" :unclickable="transformIfBoolean(group.unclickable)" :currentValue="group.nin" :items="nin" :groupIndex="groupIndex" @set="set" :class="['aggregator not-line', groupIndex === 0 ? '' : 'mt-5']" />
              <ButtonClose :groupIndex="groupIndex" @event="close" />
            </div>
          </div>
        </div>
        <ButtonIcon v-if="form.entity" text="Grupo" icon="plus" @handler="addGroup" class="and-btn mt-2" />
      </section>
    </div>
    <div :class="showContent ? 'hidden-btn' : ''" class="level-right pt-4 pb-5">
      <Button @event="back" name="Voltar" />
      <Button class="validate" :name="submitLabel" @event="submitForm" />
    </div>
  </form>
</template>

<script>
/* eslint-disable no-unreachable */

import { omit } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import { autoCompletePartners, getPartnerById, getPartnersCategories, getPartnersByCategory } from '@/services/partners'
import ContentLoading from '@/components/helpers/ContentLoading'
import { Card, InputButton, InputSelect, InputMoney, InputText, InputDate, InputSwitch, ButtonIcon, Button, ButtonClose } from '@/components/form'
import { getEntities, getEvents, getComboOptions, getPropsEntities, getPropsEvents, validateSegment } from '@/services/segments'

const initialState = () => ({
  name: '',
  partner: null,
  entity: '',
  groups: []
})

const initialGroupState = () => ({
  nin: false,
  and: true,
  frequency: false,
  unclickable: false,
  items: [initialCardState()]
})

const initialCardState = () => ({
  registerType: null,
  operators: [],
  fields: [],
  types: [],
  comboOptions: [],
  frequencyOption: null,
  weekendOption: 'all',
  datetimeOption: null,
  unclickable: false,
  unclickableType: false,
  unclickableField: false,
  type: null,
  field: null,
  operator: null,
  measure: null,
  value: null,
  and: true
})

const validateDataLabel = () => 'Validar Dados'
const saveDataLabel = () => 'Salvar Dados'

export default {
  name: 'Form',
  components: {
    Card,
    InputButton,
    InputSelect,
    InputText,
    InputSwitch,
    ButtonIcon,
    ButtonClose,
    Button,
    InputDate,
    InputMoney,
    ContentLoading
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    data: {
      type: Object,
      default: null
    },
    clone: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hasValue: true,
    inputDate: false,
    backRoute: '/',
    form: initialState(),
    loading: true,
    submitLabel: saveDataLabel(),
    entities: [],
    events: [],
    propsEntities: [],
    categories: [],
    frequency: [
      {
        id: true,
        name: 'Frequência'
      }
    ],
    registerTypes: [
      {
        id: 'events',
        name: 'Ações'
      },
      {
        id: 'props',
        name: 'Dados'
      }
    ],
    nin: [
      {
        id: false,
        name: 'Pertence'
      },
      {
        id: true,
        name: 'Não pertence'
      }
    ],
    and: [
      {
        id: true,
        name: 'E'
      },
      {
        id: false,
        name: 'OU'
      }
    ],
    frequencyOptions: [
      {
        id: 'day',
        name: 'Frequência dia'
      },
      {
        id: 'month',
        name: 'Frequência mês'
      },
      {
        id: 'week',
        name: 'Frequência semana'
      }
    ],
    datetimeOptions: [
      {
        id: 'datetime',
        formats: ['DATETIME'],
        name: 'DATA E HORAS',
        formatMask: '##/##/#### - ##:##'
      },
      {
        id: 'date',
        formats: ['DATETIME', 'DATE'],
        name: 'DATA',
        formatMask: '##/##/####'
      },
      {
        id: 'time',
        formats: ['DATETIME'],
        name: 'HORAS',
        formatMask: '##:##'
      }
    ],
    booleanOptions: [
      {
        id: true,
        name: 'true'
      },
      {
        id: false,
        name: 'false'
      }
    ],
    weekendOptions: [
      {
        id: 'all',
        name: 'Todos os dias'
      },
      {
        id: 'weekday',
        name: 'Dias de semana'
      },
      {
        id: 'weekend',
        name: 'Fins de semana'
      }
    ],
    descriptionType: [],
    partners: [],
    selectedPartner: '',
    showContent: true,
    grid: [
      { x: 135, y: 25, rx: 0, ry: 0, innerWidth: 35, innerHeight: 3 },
      { x: 140, y: 30, rx: 0, ry: 0, innerWidth: 25, innerHeight: 3 },
      { x: 132, y: 40, rx: 1, ry: 1, innerWidth: 40, innerHeight: 10 }
    ],
    mobileGrid: [
      { x: 10, y: 0, rx: 1, ry: 1, innerWidth: 20, innerHeight: 3 },
      { x: 15, y: 5, rx: 1, ry: 1, innerWidth: 15, innerHeight: 3 },
      { x: 0, y: 10, rx: 1, ry: 1, innerWidth: 30, innerHeight: 7 }
    ],
    gridCard: [
      { x: 5, y: 0, rx: 2, ry: 2, innerWidth: 60, innerHeight: 100 }
    ],
    mobileGridCard: [
      { x: 5, y: 0, rx: 2, ry: 2, innerWidth: 20, innerHeight: 30 }
    ]
  }),
  async created () {
    this.showContent = true
    await Promise.all([
      this.fetchPartnersCategories(),
      this.fetch(getEntities, 'entities'),
      this.fetch(getEvents, 'events'),
      this.fetchPartners(),
      this.onUpdate(),
      this.weekDaySelection()
    ])
    this.showContent = false
  },
  watch: {
    data: {
      immediate: false,
      deep: true,
      handler (value) {
        this.form = {
          ...this.form,
          ...value
        }
      }
    }
  },
  computed: {
    ...mapState(['configurations'])
  },
  methods: {
    async fetch (handler, field) {
      const data = await handler()
      this[field] = data
    },
    async fetchPartners() {
      const { data }  = await autoCompletePartners()
      this.partners = data.map(partner => {
        return {
          id: partner._id,
          ...partner
        }
      })
    },
    async onUpdate() {
      if (!this.data) return
      this.form = {
        ...this.form,
        ...this.data
      }
      const propsEntities = await getPropsEntities({id: this.data.entity})
      this.propsEntities = propsEntities
    },
    back() {
      this.$router.push('/')
    },
    dateOptions(format) {
      return this.datetimeOptions.filter(({ formats }) => formats.includes(format))
    },
    hasMeasure(item) {
      const has = item.fields && item.field && item.fields.find(({ id, format }) => id === item.field && format === 'NUMBER')
      return !!has
    },
    showSeparator(index = null) {
      return index !== 0
    },
    showFrequency(index = null) {
      return index === 0
    },
    isFrequency(groupIndex = null) {
      return this.form?.groups[groupIndex]?.frequency === true
    },
    hasRegisterType({ registerType = '' }) {
      return !!registerType
    },
    isProps({ registerType = '' }) {
      return registerType === 'props'
    },
    isBoolean({ format = '' }) {
      return format === 'BOOLEAN'
    },
    isNumber({ format = '' }) {
      return format === 'NUMBER'
    },
    isDate({ format = '' }) {
      return format === 'DATE' || format === 'DATETIME'
    },
    isQuantity({ field = '' }) {
      return field === 'quantity'
    },
    isCombo({ format = '' }) {
      return format.includes('COMBO')
    },
    optionsUnclickable (item, groupIndex) {
      const { form } = this
      const registerTypeDiff = !!form.groups[groupIndex].items.find(({ registerType }) => registerType !== item.registerType)
      return registerTypeDiff || this.form?.groups[groupIndex]?.frequency === true
    },
    addGroup() {
      const [currentGroup] = this.form.groups.slice(-1)
      const and = currentGroup && currentGroup.and === false ? false : true
      this.form = {
        ...this.form,
        groups: [
          ...this.form.groups,
          {
            ...initialGroupState(),
            and,
            unclickable: !and
          }
        ]
      }
      this.submitLabel = saveDataLabel()
    },
    addItem ({ groupIndex }) {
      const [currentItem] = this.form.groups[groupIndex].items.slice(-1)
      const and = currentItem && currentItem.and === false ? false : true
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: [
                ...group.items,
                {
                  ...initialCardState(),
                  and
                }
              ]
            }
        })
      }
      this.submitLabel = saveDataLabel()
    },
    close({ groupIndex, index }) {
      index === null
        ? this.removeGroup(groupIndex)
        : this.removeCard(groupIndex, index)
    },
    removeCard (_groupIndex, _index) {
      this.submitLabel = saveDataLabel()
      this.form.groups[_groupIndex].items = this.validateFirstItemsByType(this.form.groups[_groupIndex].items.filter((_, index) => index !== _index)).map((current, index) => index === 0 ? { ...current, and: true } : current)
    },
    removeGroup (_groupIndex) {
      this.submitLabel = saveDataLabel()
      this.form.groups = this.form.groups
        .filter((_, groupIndex) => groupIndex !== _groupIndex)
        .map((current, index) => index === 0
          ? { 
            ...current,
            and: true,
            unclickable: this.form.groups.length === 2 ? false : current.unclickable
          } : current)
    },
    async setPropsEntities({ item }) {
      this.form = {
        ...this.form,
        entity: item.id,
        groups: []
      }
      const propsEntities = await getPropsEntities(item)
      this.propsEntities = propsEntities
    },
    setRegisterType({ item, groupIndex, index }) {
      const name = item.id === 'props' ? 'fields' : 'types'
      const items = item.id === 'props' ? this.propsEntities : this.events
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: group.items.map((current, key) => {
                return index !== key
                  ? current
                  : { ...current, [name]: items }
              })
            }
        })
      }
    },
    datetimeFormat({ item, groupIndex, index }) {
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: group.items.map((current, key) => {
                return index !== key
                  ? current
                  : { ...current, formatMask: item.formatMask, value: null, operator: null }
              })
            }
        })
      }
    },
    andHandler({ item, value, groupIndex = null, index = null }) {
      const and = item ? item.id : value
      if (index !== null) {
        this.form = {
          ...this.form,
          groups: this.form.groups.map((group, groupKey) => {
            return groupKey !== groupIndex
              ? group
              : {
                ...group,
                items: group.items.map((current) => {
                  return { ...current, and  }
                })
              }
          })
        }
      } else {
        this.form = {
          ...this.form,
          groups: this.form.groups.map((group) => {
            return {
              ...group,
              and,
              unclickable: !and ? true : false,
              nin: !and ? false : group.nin
            }
          })
        }
      }
    },
    frequencyNumberOperators() {
      return this.configurations.operatorsByType['NUMBER'].slice(2, -2).filter(({ id }) => id !== 'ne')
    },
    frequencyDateOperators() {
      return this.configurations.operatorsByType['DATETIME'].filter(({ id }) => id === 'bt')
    },
    frequencyHandler({ groupIndex, index }) {
      const operators = this.frequencyNumberOperators()
      const operator = ''
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: group.items.map((current, key) => {
                return index !== key
                  ? current
                  : { ...current, value: '', operators, operator }
              })
            }
        })
      }
    },
    async setFrequency({ groupIndex }){
      const registerType = 'events'
      const type = 'PREREWARD'
      const unclickable = true
      const types = [{
        id: 'PREREWARD',
        name: 'Utilização'
      }]
      const descriptionOperators = [
        {
          id: 'eq',
          name: 'Igual'
        }
      ]
      const descriptionFields = [
        {
          id: 'description',
          name: 'Descricao',
          format: 'COMBO'
        }
      ]
      const quantityFields = [
        {
          id: 'quantity',
          name: 'Quantidade',
          format: 'NUMBER'
        }
      ]
      const comboOptionsRequest = getComboOptions({
        registerType: 'events',
        type: type,
        field: 'description',
        isArray: false
      })
      const dateFieldsRequest = getPropsEvents({
        id: type,
        format: 'DATETIME'
      })
      const [dateFields, comboOptions] = await Promise.all([dateFieldsRequest, comboOptionsRequest])

      const cards = [
        {
          ...initialCardState(),
          registerType,
          operators: descriptionOperators,
          fields: descriptionFields,
          comboOptions,
          types,
          type,
          unclickable,
          unclickableType: unclickable,
          unclickableField: unclickable,
          field: 'description',
          operator: 'eq',
          value: '',
          format: 'COMBO'
        },
        {
          ...initialCardState(),
          registerType,
          operators: this.frequencyDateOperators(),
          fields: dateFields,
          types,
          type,
          unclickable,
          unclickableType: unclickable,
          unclickableField: !unclickable,
          operator: 'bt',
          datetimeOption: 'date',
          field: 'dateMoviment',
          value: [],
          and: true,
          format: 'DATETIME',
          formatMask: '##/##/####'
        },
        {
          ...initialCardState(),
          registerType,
          operators: this.frequencyNumberOperators(),
          fields: quantityFields,
          types,
          type,
          unclickable,
          unclickableType: unclickable,
          unclickableField: unclickable,
          frequencyOption: 'day',
          field: 'quantity',
          format: 'NUMBER'
        }
      ]
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: cards
            }
        })
      }
      this.submitLabel = saveDataLabel()
    },
    async setFields({ item, groupIndex, index }) {
      const rest = omit(initialCardState(), ['registerType', 'types', 'and'])
      const fields = await getPropsEvents(item)
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: group.items.map((current, key) => {
                return index !== key
                  ? current
                  : { ...current, ...rest, fields }
              })
            }
        })
      }
    },
    async setFieldConfigs({ item, groupIndex, index }) {
      const rest = omit(initialCardState(), ['fields', 'types', 'type', 'registerType', 'and', 'unclickable', 'unclickableType', 'unclickableField'])
      const formItem = this.form.groups[groupIndex].items[index]
      const operators = this.isFrequency(groupIndex) && this.isDate(item) ? this.frequencyDateOperators() : this.configurations.operatorsByType[item.format]
      const comboOptions = item && item.format && item.format.includes('COMBO')
        ? await getComboOptions({
          registerType: formItem.registerType === 'props' ? 'entities' : 'events',
          type: formItem.registerType === 'props' ? this.form.entity : formItem.type,
          field: item.id,
          isArray: item.format.includes('ARRAY')
        })
        : []
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: group.items.map((current, key) => {
                return index !== key
                  ? current
                  : { ...current, ...rest, operators, format: item.format, comboOptions }
              })
            }
        })
      }
    },
    changeOperator({ groupIndex, index }) {
      this.form = {
        ...this.form,
        groups: this.form.groups.map((group, groupKey) => {
          return groupKey !== groupIndex
            ? group
            : {
              ...group,
              items: group.items.map((current, key) => {
                return index !== key
                  ? current
                  : { ...current, value: '' }
              })
            }
        })
      }
    },
    async execPromise(func) {
      try {
        this.showContent = true
        await func
      } catch (error) {
        console.loh('nada')
      } finally {
        this.showContent = false
      }
    },
    async set({ name, item, value, groupIndex, index, handler = null }) {
      this.submitLabel = saveDataLabel()
      const func = handler && this[handler]
      func && item && await this.execPromise(func({ item, groupIndex, index, value }))
      if (index !== null) {
        this.form = {
          ...this.form,
          groups: this.form.groups.map((group, groupKey) => {
            return groupKey !== groupIndex
              ? group
              : {
                ...group,
                items: group.items.map((current, key) => {
                  return index !== key
                    ? current
                    : { ...current, [name]: item ? item.id : value }
                })
              }
          })
        }
      } else if (groupIndex !== null) {
        this.form = {
          ...this.form,
          groups: this.form.groups.map((group, groupKey) => {
            return groupKey !== groupIndex
              ? group
              : {
                ...group,
                [name]: item ? item.id : value
              }
          })
        }
      } else {
        this.form = {
          ...this.form,
          [name]: item ? item.id : value
        }
      }
    },
    formatDate(item) {
      const { dateParse } = this
      const { value } = item
      const newDate = value instanceof Array ? value.map((v, k) => dateParse(item, v, k)) : dateParse(item, value)
      return newDate
    },
    dateParse(item, value, index) {
      const { datetimeOption = 'date' } = item
      const formats = {
        datetime: () => ({
          in: 'DDMMYYYYHHmm',
          out: `YYYY-MM-DD HH:mm:${index ? '59' : '00'}`
        }),
        date: () => ({
          in: 'DDMMYYYY',
          out: 'YYYY-MM-DD'
        }),
        time: () => ({
          in: 'HHmm',
          out: 'HHmm'
        })
      }
      const format = formats[datetimeOption]()
      return format ? moment(value, format.in).format(format.out) : value
    },
    orderedItems (items) {
      const ordered = items.map((item, position) => ({
        ...item,
        value: item.format === 'DATE' || 
        item.format === 'DATETIME' ? 
        this.formatDate(item) : 
        item.value,
        position
      }))
      return this.validateFirstItemsByType(ordered)
    },
    makePayload() {
      const { groups, ...form } = this.form
      form.name = form.name.toLowerCase()
      const payload = {
        ...form,
        groups: groups.map(({ items, ...group }, position) => ({
          ...group,
          position,
          events: this.orderedItems(items).filter(({ registerType }) => registerType === 'events'),
          props: this.orderedItems(items).filter(({ registerType }) => registerType === 'props')
        }))
      }
      return !this.clone
        ? payload
        : {...payload, id: ''}
    },
    validateFirstItemsByType(items) {
      return items.reduce((acc, value) => {
        const firstByType = !acc.find(v => v.registerType === value.registerType)
        if (firstByType) {
          value.and = true
        }
        return [...acc, value]
      }, [])
    },
    validateEmptyFields (groups) {
      return groups.some(group => group.items.some(item => {
        const defaultRequireds = ['value', 'operator', 'field', 'format', 'and']
        const fields = ['DATE', 'DATETIME'].includes(item.format) ? [...defaultRequireds, 'datetimeOption'] : group.frequency && ['quantity'].includes(item.field) ? [...defaultRequireds, 'frequencyOption']  : defaultRequireds
        const requiredFields = item.registerType === 'props' ? fields : [...fields, 'type']
        return requiredFields.find(field => item[field] === '' || item[field] === null || (item[field] === [] || item[field] === ['', ''] || (item[field][0] && item[field][0] === '')))
      }))
    },
    validateDate (groups) {
      return groups.some(group => group.items.some(item => {
        const isDate = item.format === 'DATETIME' || item.format === 'DATE'
        const isArray = ['bt', 'nbt'].includes(item.operator)
        const formats = {
          datetime: 'DD/MM/YYYY - HH:mm',
          date: 'DD/MM/YYYY',
          time: 'HH:mm'
        }
        const format = formats[item.datetimeOption]
        return !isDate
          ? false
          : !isArray
            ? !moment(item.value, format).isValid()
            : item.value.some(v => !moment(v, format).isValid())
      }))
    },
    validates() {
      if(!this.form.entity) throw Error('Selecione um tipo de participante!')
      if(!this.form.name) throw Error('Digite o nome da segmentação!')
      if(this.validateEmptyFields(this.form.groups)) throw Error('Preencha todos os campos!')
      if(this.validateDate(this.form.groups)) throw Error('Formato Data ou Hora inválido!')
    },
    async submitForm() {
      try {
        this.validates()
        this.showContent = true
        const payload = this.makePayload()
        if (this.submitLabel === validateDataLabel()) {
          await validateSegment(payload)
          this.submitLabel = saveDataLabel()
          this.$swalModal(
            'Sucesso',
            'Segmentação validada com sucesso!',
            'success'
          )
        } else {
          this.$emit('submit', payload) 
        }
      } catch (error) {
        error.response
        ? this.$swalModal(
            'Erro',
            'Não foi possível validar essa segmentação! Verifique os dados inseridos.',
            'error'
          )
        : this.$swalModal(
            'Erro',
            error.message,
            'error'
          )        
      } finally {
        this.showContent = false
      }
    },
    
    async fetchPartnersCategories() {
      const categories = await getPartnersCategories()
      this.categories = [...categories]
    },

    async fetchPartnersByCategory() {
      const partnerTag =  await this.getPartnerTag()
      const category = this.categories.find(
        category => String(partnerTag) === String(category._id)
      )
      const partners = await getPartnersByCategory(category.name)
      this.partners = partners.map(partner => {
        return {
          id: partner._id,
          ...partner
        }
      })
    },

    async getPartnerTag() {
      const partner = await getPartnerById(this.data.partner)
      return partner.data.tag
    },

    weekDaySelection() {
      this.form = {
        ...this.form,
        groups: this.form.groups.map(group => {
          return {
            ...group,
            items: group.items.map(item => {
              return !item.weekendOption
                ? {...item, weekendOption: 'all'}
                : item
            })
          }
        })
      }
    },
    transformIfBoolean (value) {
    if (value && (value === 'true' || value === true)) return true
    if (value && (value === 'false' || value === false)) return false
    return value
}
  }
}
</script>

<style lang="scss">
.inputSwitchDiv{
  position: relative;
  @media (max-width: 992px){
    width: 200px;
    height: 100px;
  }
  div{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.card-select{
  min-height: 300px;
  min-width: 234px;
  border: 1px solid #2d9cdb;
}
.swit{
  display: flex;
  align-items: center;
}
.box{
  margin-top: 24px;
}
.boxCard{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 100%;
  overflow: hidden;
}
.overflow-y {
  overflow-y: auto;
}
.subTitle{
  font-weight: 500;
  font-size: 14px;
  color: #6D6D77;
}
.searchSegments{
    width: 26%
}
.validate:disabled {
  color: #363636 !important;
}
.card {
  position: relative;
  .next-btn {
    position: absolute;
    margin: auto;
    right: 0;
    left: 0;
    top: 20rem;
    bottom: 0;
    transform: rotate(90deg)
  }
  // &-filter:after{
  //   @media (min-width: 992px){
  //     background-color: #2d9cdb;
  //     content: '';
  //     display: block;
  //     position: absolute;
  //     top: 50%;
  //     transform: translateY(-50%);
  //     height: 2px;
  //     right: -250px;
  //     width: 250px;
  //     pointer-events: none;
  //   }
  // }
}
.boxCard>div:nth-last-child(-n+2)>.fixed {
  display: none !important;
}
.boxCard>div:nth-last-child(-n+2)>div>.card-filter:after{
  display: none;
}
.dropdown-menu {
  top: -18.4rem;
  padding: 0px;
}
.datepicker {
  .datepicker-table {
    .datepicker-body {
      .datepicker-cell.is-selected {
        background-color: #2D9CDB !important;
      }
      .datepicker-cell.is-today {
        border: solid 1px #2D9CDB !important;
      }
    }
  }
  .has-text-primary {
    color: #2D9CDB !important;
  }
}
.control .has-icons-left .is-clearfix {
  .input {
    padding-left: 0 !important;
  }
}
.hidden-btn {
  visibility: hidden;
}
.hidden-inputs {
  display: none !important;
}
.card-filter {
  min-height: 25rem !important;
  position: relative;
  .titleCard {
    position: absolute;
    top: 12px;
  }
}
.filter-card {
  min-height: 25rem !important;
}
.group {
  &:nth-child(odd) {
	background-color:#ffffff;
	}
	&:nth-child(even) {
	background-color:#f1f1f1b8;
	}
  position: relative;
  padding: 0 20px;
  .group-content {
    overflow-x: scroll;
    margin-top: 2rem;
    min-height: 10rem;
  }
  .group-items {
    display: flex;
    flex-wrap: nowrap;
  }
  .aggregator {
    .input-switch {
      min-width: 120px;
      white-space: nowrap;
      padding-left: 5px;
      &:first-child {
        border-radius: 5px 0 0 5px;
      }
      &:last-child {
        border-radius: 0 5px 5px 0;
      }
    }
  }
  .aggregator-type {
    .input-switch {
      width: 60px;
    }
  }
  .group-header {
    display: flex;
    justify-content: start;
    position: absolute;
    left: 0;
    top: 8px;
    width: 100%;
    .header-content {
      display: flex;
      justify-content: flex-end;
    }
    .btn-close {
      cursor: pointer;
        right: 0;
    }
  }
  .empity-group {
    display: flex;
    justify-content: center;
    position: absolute;
    right: 0;
    left: 0;
    top: 80px;
    color: #2D9CDB;
    font-weight: 600;
  }
}
.and-btn {
  width: 100%;
  align-items: center;
}
.fixed {
  width: 100%;
  position: relative;
  height: 80px;
  &:before{
    content: '';
    margin: auto;
    top:0;
    right: 0;
    left: 0;
    display: block;
    background-color: #2D9CDB;
    position: absolute;
    height: 53px;
    width: 2px;
    overflow: hidden;
  }
  .circle {
    position: absolute;
    margin: auto;
    top:0;
    bottom: 0;
    right: 0;
    left: 0;
    cursor: default;
    img {
      cursor: default;
    }
  }
  img {
    width: 20px;
    transform: rotate(270deg);
  }
}
@media(max-width: 768px) {
  .aggregator {
    width: 180px !important;
    .input-switch {
      min-width: 80px !important;
    }
  }
  .group-header {
    right: 31px !important;
    top: 3px !important;
  }
  .group {
    .empity-group {
      left: 80px;
    }
    .btn-close {
      cursor: pointer;
        right: -20px !important;
    }
  }
}
</style>